import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FaultRulesSection = ({ data }) => (
    <Accordion sx={{ borderRadius: 2, '&:before': { display: 'none' } }} elevation={0}
        className="sh-card" style={{ padding: 0 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}
            sx={{ px: 3, py: 1.25, '& .MuiAccordionSummary-content': { my: 1 } }}>
            <Typography className="sync-health-section-title">Fault classification — the rules behind ours / theirs / shared</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 3, pb: 3, pt: 0 }}>
            <Typography sx={{ fontSize: 13.5, lineHeight: 1.55, mb: 1.5 }}>
                Every failed provider-run is classified by scanning its <i>error events</i> — the individual error lines emitted
                during the run. Each event is matched against the rules below (first match wins within a phase group; phase-based
                rules take priority over message-based ones). A run's bucket is then the highest-priority bucket across all its
                events, with priority order <b>ours → theirs → shared → unknown</b>.
            </Typography>
            <Typography sx={{ fontSize: 13.5, lineHeight: 1.55, mb: 1.5 }}>
                <b>Retry-loop heuristic:</b> if a single run emits <b>&gt; 10</b> <code>Bad Request</code> events (phase or
                message), it gets upgraded to <b>ours / retry_loop_bad_request</b> regardless of what the rules would otherwise say.
                A persistent stream of 400s against the same dataset almost always means we're sending something wrong and not
                backing off — like Baldwin's <code>PowerschoolClassRank</code> loop. A single 400 = shared; a thousand = ours.
            </Typography>
            {/* Pre-rendered Python-side via build_fault_rules_table_html — render verbatim. */}
            <Box
                sx={{ overflowX: 'auto' }}
                dangerouslySetInnerHTML={{ __html: data.faultRulesHtml || '' }}
            />
            <Typography sx={{ fontSize: 12, color: '#666', mt: 1.5 }}>
                The classifier lives in <code>Development/Utilities/fault_classifier.py</code>. Rules are ordered with strong phase
                signals first (e.g. <code>dataset_transform</code> is always ours, no matter the underlying error), then looser
                message signals.
            </Typography>
        </AccordionDetails>
    </Accordion>
);

export default FaultRulesSection;
